<template>
  <div>
    <h1 class="page-header">{{ $t('disciplinaryCondition.pageTitle') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create @success_create="fetchData" :edit="edit_data" @success_update="edit_data = ''"
              @cancel="fetchData"></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"></div>
              <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
                <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" class="kh-font" />
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-table :columns="columns" :records="resources" :loading="loading">
              <template v-slot="{ record }">
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.disciplinary_sub_type
                    ? record.disciplinary_sub_type.dis_sub_type_en
                    : ''
                  }}
                  |
                  {{
                    record.disciplinary_sub_type
                    ? record.disciplinary_sub_type.dis_sub_type_kh
                    : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.disciplinary_sub_type.att_status
                    ? record.disciplinary_sub_type.att_status.remark + ' ' +
                    '(' + record.disciplinary_sub_type.att_status.att_status + ')'
                    : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.number_of_discipline }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.disciplinary_activity
                    ? record.disciplinary_activity.dis_activity_en
                    : ''
                  }}
                  |
                  {{
                    record.disciplinary_activity
                    ? record.disciplinary_activity.dis_activity_kh
                    : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.disciplinary_activity.penalties
                    ? record.disciplinary_activity.penalties.penalty_type_en
                    : ''
                  }}
                  |
                  {{
                    record.disciplinary_activity.penalties
                    ? record.disciplinary_activity.penalties.penalty_type_kh
                    : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.penalty_unit }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.remarks }}
                </td>
                <td class="text-center">
                  <a href="#" title="edit" class="text-primary mr-2" @click.prevent="edit(record)">
                    <i class="fas fa-edit"></i>
                  </a>
                  <a href="#" title="delete" class="text-danger" @click.prevent="destroy(record.dis_sub_type_id)">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'condition',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      columns: [
        { name: this.$t('disciplinaryCondition.disciplinarySubType') },
        { name: this.$t('disciplinaryCondition.attStatus') },
        { name: this.$t('disciplinaryCondition.numberOfDiscipline') },
        {
          name: this.$t('disciplinaryCondition.activity')
        },
        {
          name: this.$t('disciplinaryCondition.penaltyType')
        },
        {
          name: this.$t('disciplinaryCondition.penaltyUnit')
        },
        {
          name: this.$t('disciplinaryCondition.remarks')
        },
        {
          name: this.$t('actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('disciplinaryCondition', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.disciplinaryCondition.search
      },
      set(newVal) {
        this.$store.commit('disciplinaryCondition/SET_SEARCH', newVal)
        this.$store.commit('disciplinaryCondition/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('disciplinaryCondition/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.edit_data = data
      this.$router.push(`/disciplinary-conditions/${data.dis_sub_type_id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('disciplinaryCondition/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'disciplinary-sub-type-create') {
      this.$store.commit('disciplinaryCondition/RESET_STATE')
    }
    next()
  }
}
</script>
